"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundJobService = exports.isProgressResultPayload = exports.BackgroundJobStatus = void 0;

var minimatch_1 = __importDefault(require("minimatch"));

var feature_1 = require("../log/feature");

var BACKGROUND_JOB_CACHE_EXPIRATION_SECONDS = 60 * 60; // 1 hour

var CURRENT_JOBS_CACHE_KEY = 'bg-jobs';

function backgroundJobCacheKey(identifier) {
  return "bg-job-".concat(identifier);
}

var BackgroundJobStatus;

(function (BackgroundJobStatus) {
  BackgroundJobStatus["Pending"] = "PENDING";
  BackgroundJobStatus["Processing"] = "PROCESSING";
  BackgroundJobStatus["Error"] = "ERROR";
  BackgroundJobStatus["Success"] = "SUCCESS";
})(BackgroundJobStatus || (exports.BackgroundJobStatus = BackgroundJobStatus = {}));

function isProgressResultPayload(payload) {
  var progressPayload = payload;
  return progressPayload.total !== undefined && progressPayload.total !== null && !isNaN(parseFloat(progressPayload.total.toString())) && progressPayload.current !== undefined && progressPayload.current !== null && !isNaN(parseFloat(progressPayload.current.toString()));
}

exports.isProgressResultPayload = isProgressResultPayload;
var statusMap = [BackgroundJobStatus.Pending, BackgroundJobStatus.Processing, BackgroundJobStatus.Success, BackgroundJobStatus.Error];

function getMaximumStatus(statuses) {
  if (!statuses.length) throw new Error('You must pass at least one status.');
  var maxIndex = statuses.slice(1).reduce(function (maxIndex, status) {
    var index = statusMap.indexOf(status);
    return index > maxIndex ? index : maxIndex;
  }, statusMap.indexOf(statuses[0]));
  return statusMap[maxIndex];
}

function mergeResultPayloads(payloads) {
  return payloads.slice(1).reduce(function (acc, payload) {
    if (acc && payload && isProgressResultPayload(acc) && isProgressResultPayload(payload)) {
      return Object.assign(Object.assign(Object.assign({}, acc), payload), {
        current: Math.max(payload.current, acc.current),
        total: Math.max(payload.total, acc.total)
      });
    } else return Object.assign(Object.assign({}, acc), payload);
  }, payloads[0]);
}

function getExpectedErrorDetails(err) {
  if (err && typeof err === 'object' && err.extensions && err.extensions.code && err.message) {
    var _a = err.extensions,
        code = _a.code,
        rest = __rest(_a, ["code"]);

    return {
      code: code,
      message: err.message,
      extensions: rest
    };
  } else return undefined;
}

var BackgroundJobService = /*#__PURE__*/function () {
  function BackgroundJobService(root) {
    _classCallCheck(this, BackgroundJobService);

    this._root = root;
  }

  _createClass(BackgroundJobService, [{
    key: "_getDefaultQueueIdentifier",
    value: function _getDefaultQueueIdentifier() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultIdentifier;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._root.deps.hookManager.mutateHook('feature-server:background-job-default-queue-identifier', undefined, undefined);

              case 2:
                defaultIdentifier = _context.sent;

                if (defaultIdentifier) {
                  _context.next = 5;
                  break;
                }

                throw new Error('No default background job queue identifier is registered.');

              case 5:
                return _context.abrupt("return", defaultIdentifier);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Schedules a new background job
     * @param identifier a unique identifier for the job
     * @param payload the payload to pass to the handler
     * @returns a promise resolving to the tracking identifier if one is enabled
     */

  }, {
    key: "scheduleJob",
    value: function scheduleJob(identifier, payload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var jobResource, taskIdentifier, existing, queueIdentifier, boundQueue;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jobResource = this._root.deps.resources.getResource('BackgroundJob', identifier);

                if (jobResource) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("Invalid background job identifier: ".concat(identifier));

              case 3:
                if (!(jobResource.getTrackingIdentifier && jobResource.atomic)) {
                  _context2.next = 12;
                  break;
                }

                taskIdentifier = jobResource.getTrackingIdentifier(payload);
                (0, feature_1.debug)('checking for existing background jobs with identifier %s', taskIdentifier);
                _context2.next = 8;
                return this.getJobStatus(identifier, taskIdentifier);

              case 8:
                existing = _context2.sent;

                if (!((existing === null || existing === void 0 ? void 0 : existing.status) === BackgroundJobStatus.Processing || (existing === null || existing === void 0 ? void 0 : existing.status) === BackgroundJobStatus.Pending)) {
                  _context2.next = 12;
                  break;
                }

                (0, feature_1.debug)('job already exists; doing nothing');
                return _context2.abrupt("return", taskIdentifier);

              case 12:
                if (!jobResource.getTrackingIdentifier) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 15;
                return this.updateJobStatus(identifier, jobResource.getTrackingIdentifier(payload), payload, BackgroundJobStatus.Pending);

              case 15:
                if (process.env.LAMBDA_TASK_ROOT) {
                  _context2.next = 26;
                  break;
                }

                (0, feature_1.debug)('executing IMMEDIATELY background job %s with payload %O', identifier, payload);

                if (!(process.env.NODE_ENV === 'test')) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 20;
                return this.handleJobWithoutQueue(jobResource, identifier, payload);

              case 20:
                _context2.next = 24;
                break;

              case 22:
                (0, feature_1.debug)('...but waiting 2 seconds to simulate Lambda start times...');
                new Promise(function (resolve) {
                  return setTimeout(resolve, 2000);
                }).then(function () {
                  return _this.handleJobWithoutQueue(jobResource, identifier, payload);
                })["catch"](function (err) {
                  (0, feature_1.debug)('error when processing background job immediately');
                  (0, feature_1.debug)(err);
                });

              case 24:
                _context2.next = 36;
                break;

              case 26:
                _context2.t0 = jobResource.queueIdentifier;

                if (_context2.t0) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 30;
                return this._getDefaultQueueIdentifier();

              case 30:
                _context2.t0 = _context2.sent;

              case 31:
                queueIdentifier = _context2.t0;
                boundQueue = this._root.deps.services.queue(queueIdentifier.store, queueIdentifier.identifier);
                (0, feature_1.debug)('scheduling background job %s with payload %O', identifier, payload);
                _context2.next = 36;
                return boundQueue.sendMessage({
                  identifier: identifier,
                  payload: payload
                });

              case 36:
                if (!jobResource.getTrackingIdentifier) {
                  _context2.next = 40;
                  break;
                }

                return _context2.abrupt("return", jobResource.getTrackingIdentifier(payload));

              case 40:
                return _context2.abrupt("return", null);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Gets the current status of all pending background tasks matching a specific pattern.
     * @param pattern the glob pattern to use to match background jobs
     * @returns the current status of all matching jobs
     */

  }, {
    key: "getAllJobStatus",
    value: function getAllJobStatus(pattern) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var keys, matchingKeys, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._root.deps.services.cache().setMembers(CURRENT_JOBS_CACHE_KEY);

              case 2:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.t0 = [];

              case 5:
                keys = _context3.t0;
                matchingKeys = keys.filter(minimatch_1["default"].filter(backgroundJobCacheKey(pattern)));
                _context3.next = 9;
                return this._root.deps.services.cache().batchGetKeys(matchingKeys);

              case 9:
                result = _context3.sent;
                return _context3.abrupt("return", Object.keys(result).map(function (key) {
                  return Object.assign({
                    key: key
                  }, result[key]);
                }));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Gets the current status of a pending background task.
     * @param jobIdentifier the identifier of the background job to check the status from
     * @param identifier the identifier of the individual task to check
     * @returns the current status of the job, if it's available
     */

  }, {
    key: "getJobStatus",
    value: function getJobStatus(jobIdentifier, identifier) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var jobResource, key, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                jobResource = this._root.deps.resources.getResource('BackgroundJob', jobIdentifier);

                if (jobResource) {
                  _context4.next = 3;
                  break;
                }

                throw new Error("Invalid background job identifier: ".concat(jobIdentifier));

              case 3:
                if (jobResource.getTrackingIdentifier) {
                  _context4.next = 5;
                  break;
                }

                throw new Error("Background job tracking is not enabled for ".concat(jobIdentifier));

              case 5:
                key = backgroundJobCacheKey(identifier);
                _context4.next = 8;
                return this._root.deps.services.cache().get(key);

              case 8:
                result = _context4.sent;
                return _context4.abrupt("return", result ? Object.assign(Object.assign({}, result), {
                  key: key
                }) : null);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "updateJobStatus",
    value: function updateJobStatus(jobIdentifier, identifier, payload, status, resultPayload, errorDetails) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var existing, cacheKey;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                (0, feature_1.debug)('updating status for %s to %s', identifier, status);
                (0, feature_1.debug)('...with resultPayload %O', resultPayload); // FIXME This is still prone to race conditions if it is updated VERY quickly.

                if (!(status !== BackgroundJobStatus.Pending)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return this.getJobStatus(jobIdentifier, identifier);

              case 5:
                _context5.t0 = _context5.sent;
                _context5.next = 9;
                break;

              case 8:
                _context5.t0 = undefined;

              case 9:
                existing = _context5.t0;
                cacheKey = backgroundJobCacheKey(identifier);
                _context5.next = 13;
                return this._root.deps.services.cache().put(cacheKey, {
                  identifier: jobIdentifier,
                  payload: payload || (existing === null || existing === void 0 ? void 0 : existing.payload),
                  resultPayload: mergeResultPayloads([resultPayload, existing === null || existing === void 0 ? void 0 : existing.resultPayload]),
                  errorDetails: errorDetails,
                  status: (existing === null || existing === void 0 ? void 0 : existing.status) ? getMaximumStatus([status, existing.status]) : status
                }, BACKGROUND_JOB_CACHE_EXPIRATION_SECONDS);

              case 13:
                _context5.next = 15;
                return this._root.deps.services.cache().setAdd(CURRENT_JOBS_CACHE_KEY, [cacheKey], BACKGROUND_JOB_CACHE_EXPIRATION_SECONDS);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "handleJobWithoutQueue",
    value: function handleJobWithoutQueue(resource, identifier, payload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var resultPayload;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (!resource.getTrackingIdentifier) {
                  _context6.next = 4;
                  break;
                }

                _context6.next = 4;
                return this.updateJobStatus(identifier, resource.getTrackingIdentifier(payload), payload, BackgroundJobStatus.Processing);

              case 4:
                this._root.deps.services.error.setContext('backgroundJob', payload);

                _context6.next = 7;
                return resource.handle(payload);

              case 7:
                resultPayload = _context6.sent;

                if (!resource.getTrackingIdentifier) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 11;
                return this.updateJobStatus(identifier, resource.getTrackingIdentifier(payload), payload, BackgroundJobStatus.Success, resultPayload !== null && resultPayload !== void 0 ? resultPayload : undefined);

              case 11:
                _context6.next = 20;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](0);
                (0, feature_1.warn)('error processing background job: %O', _context6.t0);

                this._root.deps.services.error.reportError(_context6.t0);

                if (!resource.getTrackingIdentifier) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 20;
                return this.updateJobStatus(identifier, resource.getTrackingIdentifier(payload), payload, BackgroundJobStatus.Error, undefined, getExpectedErrorDetails(_context6.t0));

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 13]]);
      }));
    }
  }, {
    key: "handleJob",
    value: function handleJob(receivedMessageIdentifier, _ref) {
      var identifier = _ref.identifier,
          payload = _ref.payload;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var jobResource, queueIdentifier, boundQueue;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                jobResource = this._root.deps.resources.getResource('BackgroundJob', identifier);

                if (jobResource) {
                  _context7.next = 3;
                  break;
                }

                throw new Error("Invalid background job identifier: ".concat(identifier));

              case 3:
                _context7.t0 = jobResource.queueIdentifier;

                if (_context7.t0) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 7;
                return this._getDefaultQueueIdentifier();

              case 7:
                _context7.t0 = _context7.sent;

              case 8:
                queueIdentifier = _context7.t0;
                boundQueue = this._root.deps.services.queue(queueIdentifier.store, queueIdentifier.identifier);
                _context7.prev = 10;
                (0, feature_1.debug)('processing background job %s with payload %O', identifier, payload);
                _context7.next = 14;
                return this.handleJobWithoutQueue(jobResource, identifier, payload);

              case 14:
                (0, feature_1.debug)('processing complete; removing message');
                _context7.next = 17;
                return boundQueue.deleteMessage(receivedMessageIdentifier);

              case 17:
                _context7.next = 23;
                break;

              case 19:
                _context7.prev = 19;
                _context7.t1 = _context7["catch"](10);
                (0, feature_1.warn)('error processing background job: %O', _context7.t1);

                this._root.deps.services.error.reportError(_context7.t1);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[10, 19]]);
      }));
    }
  }]);

  return BackgroundJobService;
}();

exports.BackgroundJobService = BackgroundJobService;